module.exports = __webpack_public_path__ + "static/media/ts10cr538.0cbc8230.png";